import { Box, Stack } from "@mui/material";
import { VideoCameraFront } from "@mui/icons-material";
import { LargeContentBox } from "@/components/common";
import { PageHeader } from "@/components/common/PageHeader";
import { TeleconsultoriaHome } from "src-next/modules/teleconsultoria";

export function TeleconsultoriaPage() {
  return (
    <LargeContentBox>
      {/* Mesmo encaixe do Pronto Atendimento: a grade centraliza o filho se ele não esticar. */}
      <Box sx={{ width: "100%", maxWidth: "100%", justifySelf: "stretch" }}>
        <PageHeader
          title="Teleconsultoria"
          icon={VideoCameraFront}
          // Texto neutro: a página atende prestadora (disponibilidade) e afiliada (horários).
          description="Teleconsultoria entre clínicas: teleconsultores, horários e convites."
        />
        <Stack sx={{ width: "100%" }}>
          <Box sx={{ width: "100%", maxWidth: "100%", p: 2 }}>
            {/* Sem permissão de gestão mostra só o painel de disponibilidade (como antes);
                gestor/dono da prestadora ganha também a aba de Afiliações. */}
            <TeleconsultoriaHome />
          </Box>
        </Stack>
      </Box>
    </LargeContentBox>
  );
}
